import { useMutation } from "@tanstack/react-query";
import { get2, patch } from "../axios";
import { errorToast, formatDate } from "../utils/helpers";
import useCommon from "./useCommon";
import useElectronHook from "./useElectronHook";

const usePrintReceipt = () => {
  const t = useCommon();
  const { isElectron } = useElectronHook();
  const getReceipt = useMutation({
    mutationFn: (updateData: {
      branch: number;
      orderId: number;
      isLabelPrintManuelRequest: number;
      printOnlyCustomerReceipt: number;
    }) => {
      return get2(
        `internal/secure/pos/v1/printerSettings/receipts/${updateData.branch}/${updateData.orderId}`,
        {
          params: {
            isLabelPrintManuelRequest: updateData.isLabelPrintManuelRequest,
            printOnlyCustomerReceipt: updateData.printOnlyCustomerReceipt,
          },
        },
      );
    },
  });

  const updatePrintedDate = useMutation({
    mutationFn: (updateData: {
      branch: number;
      orderId: number;
      time: string;
    }) => {
      return patch(
        `internal/secure/pos/v1/orders/information/printed/time/${updateData.branch}/${updateData.orderId}`,
        {
          date_time: updateData.time,
        },
      );
    },
  });

  return async (
    orderId: number,
    branchId: number,
    isLabelPrintManuelRequest?: number,
    printOnlyCustomerReceipt?: number,
  ) => {
    await getReceipt
      .mutateAsync({
        branch: branchId,
        orderId: orderId,
        isLabelPrintManuelRequest: isLabelPrintManuelRequest || 0,
        printOnlyCustomerReceipt: printOnlyCustomerReceipt || 0,
      })
      .then(async (data) => {
        if (data?.length > 0) {
          await updatePrintedDate.mutateAsync({
            orderId: orderId,
            time: formatDate(new Date(), "inputDateTimeWithSeconds"),
            branch: branchId,
          });
          if (isElectron) {
            window.api.send("print", data);
          } else {
            const myWindow = window.open("", "PRINT", "height=400,width=600");
            myWindow.document.write(data[0].html);
            myWindow.document.close(); // necessary for IE >= 10
            myWindow.focus(); // necessary for IE >= 10*/
            myWindow.print();
            setTimeout(() => {
              myWindow.close();
            }, 2000);
          }
          return Promise.resolve(true);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 404) {
          const message = t("printerSettingsNotFound");
          errorToast(message, "printerSettingsNotFound");
        } else if (error?.response?.status === 406) {
          const message = t("printerSettingsIsNotActive");
          errorToast(message, "printerSettingsIsNotActive");
        } else {
          errorToast();
        }
        return Promise.reject(error);
      });
  };
};

export default usePrintReceipt;
